import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CONTROVERSY_INDICES_TO_ICONS_MAP } from './constants';

export class ControversyIndex extends Component {
  static propTypes = {
    indexLabel: PropTypes.string.isRequired,
    indexValue: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      indexLabel: "",
      indexValue: ""
    };
  }

  componentDidMount() {
    this.setState({
        indexLabel: this.props.indexLabel,
        indexValue: this.props.indexValue
    });
  }

  render() {
    const {indexLabel, indexValue} = this.state;
    const indexIconSource = CONTROVERSY_INDICES_TO_ICONS_MAP[indexLabel];
    return (
      <div>
        <div className='controversy-index-label'>
          <span>
              <img
                src={indexIconSource}
                className="harm-watch-feed-icon filter-grey"
                alt={indexLabel}
              />
              {indexLabel}
          </span>
        </div>
        <div className='controversy-index-value'>
            <span>{indexValue}</span>
        </div>
      </div>
    );
  }
}

  export default ControversyIndex;


// WEBPACK FOOTER //
// ./src/features/harmwatch/components/ControversyIndex.js